/* base class that provides common menu behaviors
 * dependencies: jQuery for sliding behavior on toggle
 */

export class Menu {
    constructor(toggler, container, openClass, toggleOpenClass, speed) {
        this.toggler = toggler;
        this.container = container;
        this.openClass = openClass;
        this.toggleOpenClass = toggleOpenClass;
        this.speed = speed;
        this.open = false;
    };

    toggle() {
        let t = this.toggler;
        let tc = this.toggleOpenClass;
        let c = this.container;
        let cc = this.openClass;

        if (this.open) {
            this.open = false;
            c.classList.remove(cc);
            t.classList.remove(tc);

            $(this.container).slideUp(this.speed);
        } else {
            this.open = true;
            c.classList.add(cc);
            t.classList.add(tc);

            $(this.container).slideDown(this.speed);
        }
    };
}


// WEBPACK FOOTER //
// ./Scripts/src/menu.js